export const EVENT_SPORTS = ['run', 'trail', 'bike', 'swim', 'triathlon', 'hike', 'other'];
export const EVENT_PRIORITIES = ['A', 'B', 'C'];
export const EVENT_INTENTS = ['perform', 'complete', 'fun'];

export const EVENT_SPORT_EMOJI = {
  run: '🏃',
  trail: '⛰️',
  bike: '🚴',
  swim: '🏊',
  triathlon: '🏅',
  hike: '🥾',
  other: '🏁'
};

export const EVENT_PRIORITY_CLS = {
  A: 'bg-red-50 text-red-700 border-red-200',
  B: 'bg-amber-50 text-amber-800 border-amber-200',
  C: 'bg-sky-50 text-sky-700 border-sky-200'
};

// 'pending' (options to choose) | 'applied' | 'kept' | 'none' (no adaptation requested/proposed)
export function eventStatus(event) {
  const replan = event?.replan || null;
  if (!replan) return 'none';
  const action = replan?.decision?.action;
  if (action === 'applied') return 'applied';
  if (action === 'kept_plan') return 'kept';
  const hasOptions = Array.isArray(replan.options) && replan.options.length > 0;
  return hasOptions ? 'pending' : 'kept_by_coach';
}
